import { render, staticRenderFns } from "./restorePassMethod.vue?vue&type=template&id=86801b1a"
import script from "./restorePassMethod.vue?vue&type=script&lang=js"
export * from "./restorePassMethod.vue?vue&type=script&lang=js"
import style0 from "./restorePassMethod.vue?vue&type=style&index=0&id=86801b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports